module.exports = __webpack_public_path__ + "img/Country1-1.330cbdca.png";